<section>
  <div class="border_container">
    <div class="row align-items-center border mx-0 p-1">
      <div class="col-lg-6 col-md-12 col-sm-12 col-12">
        <h6 *ngIf="isFormView">Registrar detalle de recibo de caja</h6>
      </div>
      <div class="col-lg-6 col-md-12 col-sm-12 col-12 d-flex justify-content-end">
        <app-custom-button [label]="isChargeAccount ? 'Agregar Ctas.Cobro' : 'Agregar Facturas'" [severity]="'success'"
          [disabled]="disabledDetail" [width]="'8.5rem'" (onClick)="openInvoiceSelectionModal()"></app-custom-button>
        <app-custom-modal #invoiceSelection [label]="'Seleccionar'" [children]="componentTableSelection"
          [header]="'Selección de Documentos Pendientes de Pago Impresos'" [inputs$]="inputsForInvoicesSelection$"
          [output$]="output$" [width]="'50rem'" (selectedItems)="handleSelectedItem($event)" hidden></app-custom-modal>
      </div>
    </div>
    <div class="row mx-0" [hidden]="!isFormView">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12 border">
        <app-register-invoice-cash-receipt [cashReceiptModel]="cashReceiptModel"
          [invoiceCashReceiptContract]="invoiceCashReceiptModel" [permissionUpdatable]="permissionUpdatable"
          (isFormView)="getFormView($event)" (updateListDetail)="getInvoiceCashs()">
        </app-register-invoice-cash-receipt>
      </div>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
      <app-custom-table [headers]="detailHeader" [data]="detailData" [actions]="tableActions"
        [showCheckbox]=" !this.disabledDetail " [checkBoxAction]="checkboxActions"
        [clearSelectionTrigger]="clearSelectionTrigger" [previousFilters]="filters" [showExport]="true"
        (onPageChange)="onPageChange($event)" (onFilterChange)="onFilterChange($event)" (onExport)="onExport()"
        (onAction)="onAction($event)">
      </app-custom-table>
      <app-custom-modal #taxesModal [label]="'Seleccionar'" [header]="'Retenciones'" [inputs$]="inputsForTaxesModals$"
        [children]="componentTaxesModal" hidden [closable]="false" (params)="reloadList($event.reload)">
      </app-custom-modal>
    </div>
  </div>
</section>